export default __webpack_public_path__ + "a1a7749b4ce4360454812d05fba94340.png";